<div class="row-col" [className]="cardId=='misc'?'row-col float-right':'row-col'"
  [class.stop-left]="!stopSide || stopSide.toLocaleLowerCase() !== 'right'"
  [class.stop-right]="stopSide && stopSide.toLocaleLowerCase() === 'right'" (clickOutside)="clickOutsideEvents()"
  exclude=".newleads-modal">
  <div id="team-{{cardId}}" class="follow-up-col black-bg">
    <div class="box-title">{{cardHeading}}<ng-content/> <span class="panel-batch">{{cardList.length}}</span></div>
    @if (disabledMsg == null || disabledMsg == undefined || disabledMsg == '') {
      <div class="follow-up-panel-body">
        @for (patient of cardList; track patient; let i = $index) {
          <section [ngClass]="{'has-appointment':!!patient.appschedule}">
            @if (i<8) {
              <div class="record-list" #recordlist>
                <div class="list-name" style="white-space: nowrap" (click)="showActionmenu($event)">
                  {{(patient.firstname || patient.lastname ? patient.firstname + ' '+ patient.lastname : '(no name)')}} <span matTooltip="Lead Source">{{showLeadSource ? getLeadSource(patient) : ''}}</span>
                </div>
                <div class="action-menu" #actionmenu>
                  <span class="row-action" (click)="showAvaFollowupModal('auto',patient);">Auto</span>
                  <span class="row-action" (click)="showAvaFollowupModal('set',patient);">Set</span>
                  <span class="row-action" (click)="showAvaFollowupModal('remind',patient);">Remind</span>
                  <span class="row-action" (click)="showPatientDetailsModal(patient,PatientDetailsArea.Details)">Details</span>
                  <span class="row-action" (click)="showPatientDetailsModal(patient,PatientDetailsArea.Communication)">Messaging</span>
                  <span class="row-action stop-btn" (click)="stopPatient($event)">Remove</span>
                </div>
                <div class="stop" #stop>
                  <div class="black-block"></div>
                  <div class="ques">Are you sure you want to remove {{patient.firstname}} from {{cardHeading}}?
                  </div>
                  <div class="btn-opns">
                    <div class="cancel-stop" (click)="closeStop('cancelStop')">Cancel</div>
                    <div class="confirm-stop" (click)="closeStop('confirmStop', followUpCategoryId,  patient)">
                    Confirm</div>
                  </div>
                </div>
              </div>
            }
          </section>
        }
      </div>
    }
    @if (disabledMsg) {
      <div class="follow-up-panel-body" [style.color]="'#FFF'">
        {{disabledMsg}}
      </div>
    }
    @if (cardList.length != 0) {
      <div class="more-btn" (click)="showMoreCardPatients()">More</div>
    }
  </div>
</div>
@if (teamdShowCardPatients==true) {
  <div class="newleads-modal">
    <div class="newleads black d-flex flex-column">
      <svg class="close-newleads-modal" (click)="hideMoreCardPatients()" width="15" height="15" viewBox="0 0 15 15"
        fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="13.4995" y="14.9996" width="19.0914" height="2.12127" rx="1" transform="rotate(-135 13.4995 14.9996)"
          fill="white" />
          <rect x="15" y="1.50037" width="19.0914" height="2.12127" rx="1" transform="rotate(135 15 1.50037)"
            fill="white" />
          </svg>
          <div class="heading">{{cardHeading}}</div>
          <div class="patient-header-action-row d-flex align-items-center">
            <div class="d-flex mr-3 align-items-center">
              <mat-checkbox color="primary" class="rounded-checkbox" [checked]="isAllSelected" (change)="selectAll($event)"><span style="color: #FFF !important">All</span></mat-checkbox>
            </div>
            <div class="dropdown-holder mr-3">
              <ava-select colorMode='light' [placeholder]="(selectedPatients && selectedPatients.length) + ' selected'" [disabled]="selectedPatients.length == 0" [(ngModel)]="multiHandlingMode" (ngModelChange)="startHandleSelected()" [options]="multiHandlingModes"></ava-select>
            </div>
            <div class="ml-auto">
              <input type="text" class="form-control input-field"
                [(ngModel)]="searchFilter" (input)="setFilter()" placeholder="Name">
              </div>
              <div class="top-filters">
                <div class="newleads-batch blue">{{cardList.length}}</div>
              </div>
              <div class="stop popup" #confirm  tabindex="-1" (blur)="isShowConfirmWindow = false" [class.show]="isShowConfirmMultiHandlingWindow">
                <div class="black-block"></div>
                <div class="ques">Any patients currently in a sequence will be removed and placed into this one, are you sure you want to proceed?
                </div>
                <div class="btn-opns">
                  <div class="cancel-stop" (click)="cancelMultiHandling()">No</div>
                  <div class="confirm-stop"
                    (click)="confirmMultiHandling()">Yes
                  </div>
                </div>
              </div>
              <div class="stop popup" tabindex="-1" (blur)="isShowRemoveSelectedWindow = false" [class.show]="isShowMultiRemoveWindow">
                <div class="black-block"></div>
                <div class="ques">Are you sure you want to remove all selected users from {{cardHeading}}?
                </div>
                <div class="btn-opns">
                  <div class="cancel-stop" (click)="cancelMultiHandling()">Cancel</div>
                  <div class="confirm-stop" (click)="confirmMultiRemove(followUpCategoryId)">
                  Confirm</div>
                </div>
              </div>
            </div>
            <div class="patient-header-sort-row d-flex">
              <div class="header-sort-item pointer d-flex" (click)="sortCardList()">
                <div class="sort-item-label mr-2">Name</div>
                <div class="sort-item-icon">
                  <svg width="14" height="5" viewBox="0 0 14 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 5L7 -6.11959e-07L14 0L10.5 5Z" fill="white" />
                    <path d="M3.5 0L7 5L0 5L3.5 0Z" fill="white" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="patient-holder">
              @for (patient of displayCardList | listFilter: selectedConsult: checkOptions; track patient) {
                <div class="patient-item-wrapper d-flex">
                  <div class="checkbox-wrapper">
                    <mat-checkbox color="primary" class="rounded-checkbox" [checked]="isPatientSelected(patient)" (change)="selectRow($event, patient)"></mat-checkbox>
                  </div>
                  <div class="patient blue">
                    <div style="width: 25%; display: inline-block">{{patient.firstname + ' '+ patient.lastname}} <span matTooltip="Lead Source">{{showLeadSource ? getLeadSource(patient) : ''}}</span></div>
                    <div style="width: 20%; display: inline-block">{{patient.visitdate | date:'MM/dd/yyyy'}}</div>
                    <div style="width: 25%; display: inline-block">{{patient.responsible}}</div>
                    <div style="width: 20%; display: inline-block; ">
                      @if (patient.isEmailValid) {
                        <span (click)="showPatientDetailsModal(patient,PatientDetailsArea.Communication, CommunicationType.Email)">
                          <svg class="mail" width="25" height="25" viewBox="0 0 25 25" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.5" cy="12.5" r="12.25" fill="#2596FF" stroke="white" stroke-width="0.5" />
                            <path
                              d="M17.5093 16.835H6.95492C6.56194 16.835 6.2251 16.5048 6.2251 16.1194V8.68825C6.2251 8.30293 6.56194 7.97266 6.95492 7.97266H17.5093C17.9023 7.97266 18.2391 8.30293 18.2391 8.68825V16.1194C18.2391 16.5048 17.9023 16.835 17.5093 16.835Z"
                              stroke="white" stroke-width="0.7" stroke-miterlimit="10" />
                              <path d="M6.3374 8.41309L12.1199 12.8718L17.9023 8.41309" stroke="white" stroke-width="0.7"
                                stroke-miterlimit="10" />
                                <path d="M6.16895 15.459L9.93035 11.1654" stroke="white" stroke-width="0.7"
                                  stroke-miterlimit="10" />
                                  <path d="M18.239 15.459L14.5337 11.1654" stroke="white" stroke-width="0.7"
                                    stroke-miterlimit="10" />
                                  </svg>
                                </span>
                              }
                              <span (click)="showPatientDetailsModal(patient,PatientDetailsArea.Communication, CommunicationType.Message)">
                                <svg class="chat" width="25" height="25" viewBox="0 0 25 25" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="12.5" cy="12.5" r="12.25" fill="#2596FF" stroke="white" stroke-width="0.5" />
                                  <path
                                    d="M9.86995 9.81433C6.72231 9.81433 4.2042 11.7792 4.2042 14.1688C4.2042 15.1247 4.57143 15.9744 5.25342 16.6647C4.99111 17.0895 4.51897 17.7268 4.09928 17.6737C3.52222 17.6206 5.62064 18.6295 6.8797 17.833C7.77153 18.2578 8.82074 18.5233 9.92241 18.5233C13.0701 18.5233 15.5882 16.5585 15.5882 14.1688C15.5357 11.7792 13.0176 9.81433 9.86995 9.81433Z"
                                    fill="white" />
                                    <path
                                      d="M20.8862 14.8593C20.519 14.9124 20.0993 14.3283 19.837 13.9566C20.519 13.2131 20.9387 12.3104 20.9387 11.3545C20.9387 8.96483 18.4206 7 15.273 7C12.1253 7 9.65967 8.91173 9.65967 11.3014C9.65967 13.6911 12.1778 15.6559 15.3254 15.6559C16.4271 15.6559 17.4763 15.3904 18.3681 14.9655C19.4698 15.8152 21.4109 14.8062 20.8862 14.8593Z"
                                      fill="white" />
                                      <path
                                        d="M15.2747 15.6558C15.4321 15.3902 15.7469 14.8061 15.6944 14.0627C15.6944 13.0537 15.2223 12.3633 14.9075 11.9916C13.9632 10.664 12.5992 10.2392 12.0746 10.0799C11.2353 9.81437 10.5533 9.81437 10.0811 9.86747C9.92374 10.3985 9.66144 11.5137 10.0811 12.6289C10.8156 14.4344 12.8615 15.6558 15.2747 15.6558ZM15.2747 15.6558C15.4846 15.284 15.7469 14.6999 15.6944 14.0627"
                                        stroke="#2596FF" stroke-width="0.5" stroke-miterlimit="10" />
                                      </svg>
                                    </span>
                                    @if (patient.isPhoneValid) {
                                      <span>
                                        <a href="{{'tel:'+patient.phoneNumber}}">
                                          <svg class="call" width="25" height="25" viewBox="0 0 25 25" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12.5" cy="12.5" r="12.25" fill="#2596FF" stroke="white"
                                              stroke-width="0.5" />
                                              <path
                                                d="M16.6798 17.0287L15.2185 14.5979C15.0829 14.3762 14.8145 14.3107 14.5921 14.445L13.2206 15.2734C13.2133 15.303 13.1835 15.2958 13.1464 15.3182C13.0723 15.3629 12.9683 15.4004 12.8346 15.4306C12.8346 15.4306 12.708 15.4312 12.6113 15.439C12.2759 15.3887 10.7466 13.8841 9.39205 10.7564C9.30892 10.579 9.17247 10.2314 9.31897 9.88997C9.39946 9.68959 9.54773 9.60004 9.65893 9.53288L11.0675 8.68215C11.2899 8.54783 11.355 8.28085 11.2194 8.0592L9.69843 5.61377C9.56287 5.39213 9.2944 5.32663 9.072 5.46096L8.06396 6.09508C7.66346 6.31168 7.413 6.6906 7.28185 7.09863C7.23031 7.18034 7.20137 7.299 7.15795 7.47699C7.07834 7.8033 6.99962 8.25555 7.11701 9.06993C7.19645 9.78077 7.34913 10.3209 7.38708 10.4244C8.00506 12.5553 9.13385 14.2764 9.13385 14.2764C9.13385 14.2764 10.1723 15.8498 11.7233 17.2654C12.2701 17.7445 12.8838 18.2085 13.7715 18.4565C13.9803 18.5074 14.1593 18.5511 14.2858 18.5505C14.6809 18.6155 15.1121 18.5321 15.4827 18.3082L16.4836 17.7037C16.7503 17.5174 16.8154 17.2504 16.6798 17.0287Z"
                                                fill="white" />
                                              </svg>
                                            </a>
                                          </span>
                                        }
                                      </div>
                                      <div style="width: 10%; display: inline-block; text-align:right; position: relative; cursor: pointer;">
                                        <img src="assets/images/option-btn.png" width="33" height="28"
                                          (click)='openPopupActionMenu($event)' />
                                          <div>
                                            <div class="action-menu" #actionmenu>
                                              <span class="row-action"
                                              (click)="showAvaFollowupModal('auto',patient); teamdShowCardPatients=false;">Auto</span>
                                              <span class="row-action"
                                              (click)="showAvaFollowupModal('set',patient); teamdShowCardPatients=false;">Set</span>
                                              <span class="row-action"
                                              (click)="showAvaFollowupModal('remind',patient); teamdShowCardPatients=false;">Remind</span>
                                              <span class="row-action" (click)="showPatientDetailsModal(patient,PatientDetailsArea.Details)">Details</span>
                                              <span class="row-action" (click)="showPatientDetailsModal(patient,PatientDetailsArea.Communication)">Messaging</span>
                                              <span class="row-action stop-btn" (click)="stopPopupPatient($event)">Remove</span>
                                            </div>
                                            <div class="stop" #stop>
                                              <div class="black-block"></div>
                                              <div class="ques">Are you sure you want to remove {{patient.name}} from {{cardHeading}}?
                                              </div>
                                              <div class="btn-opns">
                                                <div class="cancel-stop" (click)="closePopupStop($event, 'cancelStop')">Cancel</div>
                                                <div class="confirm-stop"
                                                  (click)="closePopupStop($event, 'confirmStop', followUpCategoryId, patient)">Confirm
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
